import TicketInventoryService from '../services/TicketInventoryService'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logoBase64 from "../imgs/mohLogo";
import util from "./util"; 
import {
    message
} from 'antd';

const stockTransactionTitle = "Logs Report";
const tableHeaderFillColor = '#CE4839';
const tableHeaderTextColor = '#FFFFFF';
const footerDarkBlueColor = '#376A9C';
const rectColor = '#36C2D2';


const dateToday =util.getCurrentDateTime();  //DD-MM-YY HH:mm
// Define logo dimensions and position
const imgWidth = 40; // Adjust the width as needed
const imgHeight = 20; // Adjust the height as needed
const logoX = 24;
const logoY = 4;

/*
*Generates PDF reports 
*/
class logs{
    /***********************************************************
    *generates downloadale stock transactions report  pdf report 
    * based on  supplied orientation 
    *@param myorientation : ENUM=> Orientation
    ***************************************************************/
 generateStockTransactionsReport=(sdataRef,myorientation)=>{
    if(!Object.values(util.Orientation).includes(myorientation)){
        throw new Error("Invalid orientation use 'landscape' or potrait");
    }

    TicketInventoryService.lists1131(sdataRef.current).then(({ data }) => {
        let header = {
            
            user:'USERNAME',
            eventType: 'Event Type',
              timestamp:'Time Stamp',
              ipAddress: 'Ip Address',
              deviceType: 'DeviceType',
              
              module: 'Module',
              details: 'Details',
        };
        //const myData = util.testJson;
        const tableData =data.result.data.map(item => [
            item.user,
            item.eventType,
            item.timestamp,
            item.ipAddress,
            item.deviceType,
            item.module,
            item.details,
        ]);
        // Create a new jsPDF instance
        const doc = new jsPDF({orientation:myorientation});
        // Draw rectangles
        this.printReportHeader(doc);
        this.printStocktransactionsTitle(doc);

        // Add the table
        doc.autoTable({
            head: [Object.values(header)],
            body: tableData,
            margin: { bottom: 30},
            tableLineWidth:0.5,
            tableLineColor:0,  
            startY: 50,
            headStyles: {
                fillColor: tableHeaderFillColor,
                textColor: tableHeaderTextColor,
                fontSize: 7
            },
            bodyStyles: {
                fontSize: 7 // Decrease the font size by 5 (default is 12)
            },  didDrawPage: (data) => {
                // Add header/footer or other elements if needed
                this.pageFooterPrint(doc, imgHeight, dateToday);
            }
        });
        // After the table is drawn, add the total page count
    this.pageNumberPrint(doc, imgHeight);
    doc.save('Logs Summary.pdf');
    }).catch(e => {
        message.error(e.message);
    }).finally(() => {
        util.hideLoader();
    });
}

    /**Private methods**/
    printStocktransactionsTitle(doc) {
        const title = stockTransactionTitle;
        doc.setFontSize(16);
        const pageWidth = doc.internal.pageSize.width;
        const titleX = pageWidth / 2;
        doc.text(title, titleX, 40, { align: 'center' });
    }

    printReportHeader(doc) {
        doc.setFillColor(rectColor);
        doc.rect(0, logoY, logoX, imgHeight - 10, 'F'); // Left rectangle
        doc.rect(logoX + imgWidth, logoY, doc.internal.pageSize.width - (logoX + imgWidth), imgHeight - 10, 'F'); // Right rectangle

        // Add the logo
        doc.addImage(logoBase64, 'PNG', logoX, logoY, imgWidth, imgHeight);
    }

    pageFooterPrint(doc, imgHeight, dateToday) {
        doc.setFontSize(10);
        // Add footer
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.width;


        doc.setFillColor(footerDarkBlueColor);
        doc.rect(0, pageHeight - imgHeight + 10, pageWidth, imgHeight - 10, 'F');

        const x1 = pageWidth - 60;
        const y1 = pageHeight;
        const x2 = pageWidth;
        const y2 = pageHeight;
        const x3 = pageWidth;
        const y3 = pageHeight - imgHeight;
        const x4 = pageWidth - 40;
        const y4 = pageHeight - imgHeight;

        doc.setFillColor(rectColor);
        // Draw the half trapezium
        doc.lines([[x2 - x1, y2 - y1], [x3 - x2, y3 - y2], [x4 - x3, y4 - y3], [x1 - x4, y1 - y4]], x1, y1, [1, 1], 'F');
        // Coordinates for the oblong circle
        const centerX = (x1 + x2 + 30) / 2;
        const centerXX = (x1 + x2) / 2;
        const centerY = y1 - (imgHeight + 11) / 2;
        const radiusX = (pageWidth - centerXX) / 2;
        const radiusY = imgHeight / 2;
        // Draw the oblong circle
        doc.setFillColor('#FFFFFF'); // White color
        doc.ellipse(centerX, centerY, radiusX, radiusY, 'F');
        doc.setFontSize(10);
        doc.setFontSize(9);
        doc.text(`Generated on: ${dateToday}`, 5, y4 + 5);
    }

    pageNumberPrint(doc, imgHeight) {
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            const pageHeight = doc.internal.pageSize.height;
            const pageWidth = doc.internal.pageSize.width;
            const x1 = pageWidth - 60;
            const y1 = pageHeight;
            const x2 = pageWidth;
            const centerXX = (x1 + x2) / 2;
            const centerY = y1 - (imgHeight + 11) / 2;
            doc.setFontSize(10);
            doc.text(`Page ${i} / ${totalPages}`, centerXX + 2, centerY + 3);
        }
    }
}
export default new logs();